import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { useTrackEvent } from "lib/mixpanel"
import { TRACKING_EVENTS } from "lopermut"
import { CampaignResponseDataSchema, UpdateCampaignStatusSchema } from "schema"
import { z } from "zod"
import { getCampaignQueryKey } from "../lib/campaignQuery"
import { getCampaignsQueryKey } from "../lib/campaignsQuery"

export const useUpdateCampaignStatusMutation = (id: string) => {
  const trackEvent = useTrackEvent()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: z.infer<typeof UpdateCampaignStatusSchema>) => {
      const { data } = await axios.patch<{ data: z.infer<typeof CampaignResponseDataSchema> }>(
        `/campaigns/${id}`,
        payload,
      )

      trackEvent(TRACKING_EVENTS.CAMPAIGN_STATUS_UPDATED, {
        campaignId: data.data.id,
        campaignStatus: data.data.status,
      })

      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getCampaignQueryKey(id) })
      queryClient.invalidateQueries({ queryKey: getCampaignsQueryKey() })
    },
  })
}
